module.exports = __webpack_public_path__ + "static/media/app-brasal-inc-mobile.449c36d3.jpg";